(function () {
    'use strict';

    angular
      .module('app.cart.testoonPartialShipping', [])

      .directive('testoonPartialShipping', function () {

          return {
              restrict: 'A',
              controllerAs: 'partialCtrl',
              /* @ngInject */
              controller: ["HttpService", "AppService", function (HttpService, AppService) {
                  var ctrl = this;

                  //ctrl.checked = data
                  AppService.getParams()
                      .then(function (data) {
                          ctrl.checked = data.Cart.CheckBox1;
                      });
                  
                  ctrl.check = function () {
                      ajaxSetPartialShipping();
                  };

                  function ajaxSetPartialShipping(value) {
                      HttpService.post({
                          url: 'Cart/AllowPartialShipping/' + ctrl.checked
                      });
                  }
              }]
          }
      });

})();